import React from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Avatar from '@material-ui/core/Avatar'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import { SlackUser } from 'hooks/useSlackUsers'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: 'absolute',
      bottom: '100%',
      left: 0,
      right: 0,
      marginBottom: theme.spacing(1),
      maxHeight: 200,
      overflowY: 'auto',
      zIndex: 1000,
    },
    listItem: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    selectedItem: {
      backgroundColor: theme.palette.action.selected,
    },
    avatar: {
      width: 32,
      height: 32,
    },
  })
)

interface MentionSuggestionsProps {
  users: SlackUser[]
  selectedIndex: number
  onSelect: (user: SlackUser) => void
}

export function MentionSuggestions({ users, selectedIndex, onSelect }: MentionSuggestionsProps) {
  const classes = useStyles()

  if (users.length === 0) {
    return null
  }

  return (
    <Paper className={classes.paper} elevation={3}>
      <List dense>
        {users.map((user, index) => {
          const displayName = user.displayName

          return (
            <ListItem
              key={user.id}
              className={`${classes.listItem} ${
                index === selectedIndex ? classes.selectedItem : ''
              }`}
              onClick={() => onSelect(user)}
            >
              <ListItemAvatar>
                <Avatar src={user.pfp} alt={displayName} className={classes.avatar}>
                  {displayName.charAt(0).toUpperCase()}
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={displayName} secondary={displayName} />
            </ListItem>
          )
        })}
      </List>
    </Paper>
  )
}
